import { datadogLogs } from '@datadog/browser-logs';
import { signInWithRedirect } from 'aws-amplify/auth';

import { signOut } from 'src/common/external/aws/signOut';

// Route through Cognito's Hosted UI via Amplify's OAuth flow rather than a
// hand-built /login URL: v6 validates a `state` param on the return trip that
// only exists if Amplify itself initiated the redirect.
export async function redirectUnauthedUser() {
  try {
    await signInWithRedirect();
  } catch (err) {
    const errorName = (err as { name?: string } | undefined)?.name;
    // v6 throws UserAlreadyAuthenticated while it still holds a session — i.e.
    // /profile failed for a reason re-login can't fix (backend rejecting a
    // still-valid token, clock skew). Retrying would silently re-auth off the
    // live Hosted-UI cookie and loop, so sign out fully to clear that cookie.
    if (errorName === 'UserAlreadyAuthenticatedException') {
      datadogLogs.logger.warn('auth.redirect.stale_session_signout');
      try {
        await signOut();
      } catch (signOutErr) {
        // Must not reject: a fire-and-forget rejection here reintroduces the
        // blank screen this function exists to prevent.
        datadogLogs.logger.error(
          'auth.redirect.signout_failed',
          {},
          signOutErr instanceof Error ? signOutErr : undefined
        );
      }
      return;
    }
    // Surface to Datadog rather than leave an unhandled rejection, which would
    // render a blank screen.
    datadogLogs.logger.error(
      'auth.redirect.failed',
      { auth: { errorName } },
      err instanceof Error ? err : undefined
    );
  }
}
